import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { TocynService } from '../gwasanaethau/defnyddiwr/tocyn.service';

@Injectable()
export class HttpTocynRhyngGipio implements HttpInterceptor {

    constructor(private tocynService: TocynService) { }

    intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // Method isod yn aros tan mae'r tocyn wedi dychwelyd, felly unrhyw request yn cael ei oedi
        return this.tocynService.nolTocynMynediadDilys().pipe(
            switchMap(tocyn => {

                const headersConfig = {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Accept': 'application/json',
                    'Authorization': tocyn
                };

                const cais = tocyn
                    ? httpRequest.clone({
                        setHeaders: headersConfig
                    })
                    : httpRequest;

                return next.handle(cais);
            })
        );
    }
}
